export const isDev = import.meta.env.DEV
export const gitDefine = __GIT_DEFINE__
